import { render, staticRenderFns } from "./ModalBulkItemImport.vue?vue&type=template&id=59bd04ba&scoped=true&"
import script from "./ModalBulkItemImport.vue?vue&type=script&lang=js&"
export * from "./ModalBulkItemImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bd04ba",
  null
  
)

export default component.exports